import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TableFilter } from '@app/interfaces';
import { TableComponent } from '../../../components/table/table.component';
import { TitleButtonsComponent } from '../../../components/title/title-buttons/title-buttons.component';
import { FiltersComponent } from '../filters/filters.component';

@Component({
	selector: 'formly-table',
	template: `
		<div *ngIf="filter" class="linq-card--legacy">
			<sl-filters
				[showChipKey]="props.showChipKey || false"
				[searchOnly]="props.searchOnly || false"
				[hideSearch]="props.hideSearch || false"
				[fields]="props.filterFields ?? {}"
				[filters]="props.filters ?? {}"
				[config]="props.filtersConfig ?? {}"
				[disableFilters]="props.disableFilters || false"
				[clearSearch]="props.clearSearchFilter || false"
				(filtersUpdated)="applyFilter($event)"
			></sl-filters>
		</div>
		<div class="{{ props.class || 'left-buttons-position' }}" *ngIf="props.titleButtons">
			<sl-title-buttons [buttons]="props.titleButtons"></sl-title-buttons>
		</div>
		<div class="{{ props.class || 'formly-table-container' }}">
			<sl-table
				[data]="props.data || []"
				[config]="props.config"
				[filters]="props.filters || []"
				[retainSelectionsOnFilter]="props.retainSelectionsOnFilter || false"
				[selectionSelectAll]="props.selectionSelectAll || false"
				[initialSelectedData]="props.initialSelectedData || []"
				(selectionChanged)="onSelectionChanged($event)"
				[noDataText]="props.noDataText || 'No Data'"
			></sl-table>
		</div>
	`,
	styleUrls: ['./formly-table.component.less'],
	standalone: true,
	imports: [NgIf, FiltersComponent, TitleButtonsComponent, TableComponent],
})
export class FormlyTableComponent extends FieldType implements OnInit {
	filter = false;

	ngOnInit(): void {
		this.filter = this.props.activeFilter ? this.props.activeFilter : false;
	}

	onSelectionChanged(selected: any[]) {
		if (this.props.onSelectionChanged) {
			this.props.onSelectionChanged(selected);
			if (this.props.onChange) {
				this.props.onChange(this.field);
			}
		}
	}

	applyFilter(filterValue: Partial<TableFilter<any>>): void {
		this.props.filters = { ...this.props.filters, ...filterValue };
	}
}
